import { apiClient } from './client';
import { TemplatePreviewRequest, TemplatePreviewResponse } from '../types';

export const previewTemplate = (req: TemplatePreviewRequest) =>
  apiClient.post<TemplatePreviewResponse>('/api/templates/preview', req).then(r => r.data);
